module.exports = __webpack_public_path__ + "img/pic-3.52f114db.png";